// Behavior-level. No table names, cron internals, or the three-state checker
// logic framed as implementation — just observable behavior.

export default {
  title: 'Bundle Tracker',
  summary:
    'Keep approved app-bundle lists across your DSPs, bulk-import and check bundles, define the seller lines each list should carry, and get a daily crawl that flags when a line drops or an app leaves the store.',

  sections: [
    {
      h: 'What this tool does',
      p: [
        'Holds named lists of app bundles — per DSP, per deal, however you organize — with mandatory change notes, so every add and removal carries a reason.',
        'Lets you bulk-import, search, move, and check bundles across all lists at once. You can also define the DSP / seller lines a list is expected to carry, then a daily crawl re-checks each bundle and flags two things: a line that has gone missing, and an app that is no longer on the store.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        'You manage approved app inventory at scale and need a system of record with an audit trail.',
        "You've placed lines with app publishers and want to know the moment one disappears.",
        'You need to check a batch of bundles against your approved lists quickly.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Create a list** under Create Lists, then add bundles by hand or via bulk import. Notes are required on changes.',
        '**Define the DSP lines** the list should carry under DSP Lines — that\u2019s what the daily crawl checks for.',
        '**Let the daily crawl run** (or check on demand). Alerts group by crawl day and by line.',
        '**Action the alerts** — expand any alert to pull the exact bundle IDs and copy them out for your DSP.',
        '**Use Check Bundles** any time to test a batch against every list at once.',
      ],
    },
    {
      callout:
        'An app is only reported "gone" when every storefront checked gives a clean negative. A throttled or inconclusive store response is treated as inconclusive, not a false "app removed" alert — and missing-line alerts only fire on a successful crawl, never on a failed fetch.',
    },
  ],

  faqs: [
    {
      q: "A bundle shows a missing line but it's in the file.",
      a: 'Check the relationship — a line present as the wrong type (DIRECT vs RESELLER) for the context can still read as not authorized.',
    },
    {
      q: 'Why are notes mandatory on changes?',
      a: 'The change history is your audit trail. A bundle removed "flagged by partner for fraud" is only useful months later if the reason is attached to it.',
    },
    {
      q: 'What do Enrich and backfill do?',
      a: 'They fill in app names and developer domains for your bundles, so the lists stay readable and the daily crawl can resolve each app\u2019s app-ads.txt.',
    },
  ],
};
